import React from "react";
import { getFiiAndDiiData } from "../../services/TradingMallService";
import FiiAndDiiTradingActivity from "./FiiAndDiiTradingActivity";

interface FiiAndDiiTradingActivityServerProps {
  heading?: string;
  date?: string;
  unitLabel?: string;
  className?: string;
  cashLabel?: string;
  futuresLabel?: string;
  componentPosition?: string;
}

const FiiAndDiiTradingActivityServer = async ({
  heading,
  date,
  unitLabel,
  className,
  cashLabel,
  futuresLabel,
  componentPosition,
}: FiiAndDiiTradingActivityServerProps) => {
  const data = await getFiiAndDiiData();
  return (
    <FiiAndDiiTradingActivity
      data={data}
      heading={heading}
      date={date}
      unitLabel={unitLabel}
      className={className}
      cashLabel={cashLabel}
      futuresLabel={futuresLabel}
      componentPosition={componentPosition}
    />
  );
};

export default FiiAndDiiTradingActivityServer;
